import { Player } from '@lottiefiles/react-lottie-player';
import starData from '../../assets/lottie/star.json';

const DATA = { star: starData };

/**
 * 핑크페이퍼 Lottie 애니메이션 래퍼
 * @param {string} type - 'star' 등 애니메이션 종류
 * @param {number} size - 크기(px), 기본 120
 * @param {boolean} loop - 반복 여부, 기본 true
 * @param {boolean} autoplay - 자동 재생, 기본 true
 * @param {string} className - 추가 클래스
 */
export default function PaperLottie({ type = 'star', size = 120, loop = true, autoplay = true, className = '' }) {
  const src = DATA[type];
  if (!src) return null;
  return (
    <Player
      autoplay={autoplay}
      loop={loop}
      src={src}
      style={{ width: size, height: size }}
      className={className}
    />
  );
}
